import {
  approvalHistoryQueryKey,
  governanceAuditQueryKey,
  governanceRequestQueryKey,
  pendingApprovalsQueryKey,
  withdrawalRequestsQueryKey,
} from './governance-review.api';
import {
  businessAdminsQueryKey,
  businessTradersQueryKey,
  traderRequestsQueryKey,
  tradingAuthorityQueryKey,
} from './trading-governance.api';

const requestKeys = [
  pendingApprovalsQueryKey,
  approvalHistoryQueryKey,
  governanceAuditQueryKey,
  governanceRequestQueryKey,
];

const traderKeys = [businessTradersQueryKey, tradingAuthorityQueryKey, traderRequestsQueryKey];

const adminKeys = [businessAdminsQueryKey, tradingAuthorityQueryKey, traderRequestsQueryKey];

/**
 * Query prefixes to refetch when a governance notification arrives.
 * The open tab refetches immediately. A tab that is not open refetches when it is shown.
 */
export const governanceQueryKeysFor = (actionType: string) => {
  if (actionType === 'AddTrader' || actionType === 'UpdateTradingMandate' || actionType === 'RemoveTrader') {
    return [...traderKeys, ...requestKeys];
  }

  if (actionType === 'AddBusinessAdmin') {
    return [...adminKeys, ...requestKeys];
  }

  if (actionType === 'Withdrawal') {
    return [withdrawalRequestsQueryKey, ...requestKeys];
  }

  return requestKeys;
};
